import React, { FC } from 'react'
import { Typography, makeStyles } from '@material-ui/core'

import { IPlayer } from 'protos'
import Paper from 'components/Paper'
import T from 'components/FormattedMessage'
import TeamWithPlaceholders from 'components/TeamWithPlaceholders'

type Props = {
  selectedPlayers: IPlayer[]
  onPlayerClick: (player: IPlayer) => void
}

const useStyles = makeStyles(theme => ({
  team: {
    marginTop: theme.spacing() * 2,
    minHeight: 80
  },
  emptyHelp: {
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    margin: 'auto',
    padding: theme.spacing(),
    whiteSpace: 'nowrap'
  },
}))

const SelectedTeam: FC<Props> = ({ selectedPlayers, onPlayerClick }) => {
  const classes = useStyles()

  return (
    <>
      <TeamWithPlaceholders
        className={classes.team}
        players={selectedPlayers}
        onPlayerSelected={onPlayerClick}
      />
      {selectedPlayers.length < 1 && (
        <Paper className={classes.emptyHelp}>
          <Typography>
            <T id="teameditor_empty_help" />
          </Typography>
        </Paper>
      )}
    </>
  )
}

export default SelectedTeam
try {
    // @ts-ignore
    SelectedTeam.displayName = "SelectedTeam";
    // @ts-ignore
    SelectedTeam.__docgenInfo = { "description": "", "displayName": "SelectedTeam", "props": { "selectedPlayers": { "defaultValue": null, "description": "", "name": "selectedPlayers", "required": true, "type": { "name": "any[]" } }, "onPlayerClick": { "defaultValue": null, "description": "", "name": "onPlayerClick", "required": true, "type": { "name": "(player: any) => void" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/TeamEditor/components/SelectedTeam.tsx#SelectedTeam"] = { docgenInfo: SelectedTeam.__docgenInfo, name: "SelectedTeam", path: "src/components/TeamEditor/components/SelectedTeam.tsx#SelectedTeam" };
}
catch (__react_docgen_typescript_loader_error) { }